var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7DF1E",
    fillRule: "nonzero",
    points: "0 0 60 0 60 60 0 60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.7761905 50.1403809L20.3678095 47.361619C21.253619 48.9321905 22.0594286 50.2610477 23.9922858 50.2610477 25.8450476 50.2610477 27.0131428 49.5362857 27.0131428 46.7172382L27.0131428 27.5458095 32.6516191 27.5458095 32.6516191 46.7969524C32.6516191 52.6369523 29.228381 55.2951429 24.234 55.2951429 19.7234286 55.2951429 17.1051429 52.9590476 15.7760952 50.1399047M35.7142856 49.5361905L40.3053333 46.878C41.5139048 48.8517143 43.0846666 50.3015238 45.8635237 50.3015238 48.1998096 50.3015238 49.689619 49.1334286 49.689619 47.522381 49.689619 45.5891428 48.1592381 44.9043809 45.5815237 43.7770477L44.1722857 43.1724762C40.1041905 41.4409523 37.4056191 39.2660953 37.4056191 34.6745714 37.4056191 30.4456191 40.6276191 27.2234285 45.6622856 27.2234285 49.2468572 27.2234285 51.8244762 28.4720953 53.6769523 31.7344763L49.286857 34.5536191C48.3201905 32.8219048 47.2733334 32.1373334 45.662381 32.1373334 44.0110477 32.1373334 42.9638095 33.1844761 42.9638095 34.5536191 42.9638095 36.245238 44.0110477 36.9300952 46.4273334 37.9773333L47.8368572 38.5814285C52.6297144 40.635619 55.3282856 42.7297144 55.3282856 47.4418095 55.3282856 52.5168572 51.3410477 55.2956191 45.9844763 55.2956191 40.7486667 55.2956191 37.3654287 52.7986666 35.714381 49.5361905"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsSkills);
export default __webpack_public_path__ + "static/media/js-skills.95328eaab24e80e467aa95fc31c3fcad.svg";
export { ForwardRef as ReactComponent };